<template>
  <!-- READ ONLY MODE -->

  <div v-if="mode == 'VIEW'">
    <div v-if="!question.templateImageUrl">
      <div class="question-container">
        <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
        <div class="instruction_title ql-editor p-0 mb-15 content_flow_set" v-html="question.formattedTitle"></div>
      </div>
      <div class="instruction_info ql-editor content_flow_set p-0" v-html="question.formattedInformation"></div>
      <div class="row mt-10">
        <div class="col-sm-6 col-md-6 col-lg-6">
          <div v-if="question.imageUrl">
            <img alt="instruction" class="img-size" :src="question.imageUrl" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="pl-0 col-md-6 col-lg-6">
          <div class="question-container">
            <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
            <div class="instruction_title ql-editor p-0 mb-15 content_flow_set" v-html="question.formattedTitle"></div>
          </div>
          <div class="instruction_info ql-editor p-0 content_flow_set" v-html="question.formattedInformation"></div>
          <div v-if="question.imageUrl">
            <img alt="instruction" class="img-size" :src="question.imageUrl" />
          </div>
        </div>
        <div class="col-md-6 col-lg-6">
          <div class="instruction_title ql-editor p-0">
            <p>Template Image</p>
          </div>
          <div v-if="question.templateImageUrl">
            <img alt="templateimage" class="img-size" :src="question.templateImageUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="pt-20 screen-title">
      <div class="mb-15">
        <span class="example" @click="openInstructionModal()">Instruction screen example</span>
      </div>
      <div class>Screen title</div>
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <quill-editor class="bg-white mb-30 white-space-pre-line" v-model="question.formattedTitle" :options="editorOptionForInstruction"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div class="pt-20">
      <div class>Screen content</div>
      <quill-editor class="instruction-screen bg-white mb-30 white-space-pre-line" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOption" @focus="onEditorFocus" @ready="onEditorReady($event)"></quill-editor>
    </div>
    <div class="row pt-20">
      <div class="pb-10">Image:</div>
      <div class="row">
        <div class="col-lg-2 pl-0 pr-20" v-if="question.imageUrl">
          <img alt="instruction" class="img_size" :src="question.imageUrl" />
        </div>
        <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 p-0">
          <div class="file_container1">
            <span class="file_container_text1">Upload</span>
            <input
              type="file"
              style="width: 100%"
              class="form-control-file"
              id="file_upload"
              accept="image/*"
              v-on:change="
                uploadInstructionImage($event);
                return false;
              "
            />
          </div>
        </div>
        <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10 p-0">
          <span class="instruction pl-15 display-block color_898989">Recommended: 390px by 390px</span>
        </div>
      </div>
    </div>
    <div id="instructionModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content pt-15 pb-30 pl-30 pr-15">
          <div>
            <i class="fa fa-times cancelImage" aria-hidden="true" @click="closeModal()"></i>
          </div>
          <div class="pr-15 pt-20">
            <img alt="graphic" src="static/img/graphic-instruction-example.png" />
          </div>
        </div>
      </div>
    </div>
    <activity-video-upload-modal ref="activityVideoUploadModal" @insertVideo="insertVideoInEditor" :question="question" :moduleName="onActivityModuleName" />
  </div>
</template>

<script>
import { Quill, quillEditor } from "vue-quill-editor";
import _ from "lodash";
import localStorage from "@/services/localStorage";
import QlVideoUploadService from "@/services/ql-video-upload";
import ActivityVideoUploadModal from "@/components/common/activity-video-upload-modal";

const MODULE_NAME = "activity";
export default {
  name: "ActivityStepInstruction",
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    ActivityVideoUploadModal,
    quillEditor
  },
  data() {
    return {
      editorOption: {
        placeholder: "Enter content for this topic",
        modules: {
          toolbar: {
            container: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], ["localVideoUpload"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]],
            handlers: {
              localVideoUpload: this.customVideoButtonHandler
            }
          }
        }
      },
      editorOptionForInstruction: {
        placeholder: "Enter screen title",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      isAddHelpEnabled: false,
      editorFocused: null,
      onActivityModuleName: MODULE_NAME
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    const VideoBlot = require("@/utils/quill-video-tag-blot");
    Quill.register(VideoBlot);
    this.$nextTick(() => {
      // The whole view is rendered, so I can safely access or query
      this.initLocalVideoUploadButton(); // initialize the audio icon so that it can be displayed
    });
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    openInstructionModal() {
      window.$("#instructionModal").modal("show");
    },
    uploadInstructionImage(event, isInstructionTemplate) {
      const activityId = this.activityDetails.id;
      const self = this;
      const selectedImage = event.target.files[0];
      const input = window.document.getElementById("file_upload");
      if (input.files[0] && this.validateImage(input.files[0]) == null) {
        this.$toastr.error("Image upload failed. Please try again.");
        event.target.value = null;
        return;
      }
      const prevImageId = this.question && this.question.imageId ? this.question.imageId : "";
      const imageId = `img_id_${Math.random()
        .toString(36)
        .substr(2, 10)}`;
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: input.files[0].name,
          contentType: input.files[0].type,
          sequence: this.question.sequence,
          previousImageId: prevImageId,
          imageId: imageId,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityUploadFact(activityId, file, isInstructionTemplate).then(
          response => {
            if (response.data.result.imageUrl) {
              self.question.imageUrl = response.data.result.imageUrl;
              self.question.imageId = response.data.result.imageId;
            } else if (response.data.result.templateImageUrl) {
              self.question.templateImageUrl = response.data.result.templateImageUrl;
              self.question.templateImageId = response.data.result.templateImageId;
            }
            this.$toastr.success("Image uploaded successfully");
            if (isInstructionTemplate) {
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              window.$('#file_upload[type="file"]').val(null);
            }
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(self.errorMsg);
            if (isInstructionTemplate) {
              self.question.templateImageUrl = "";
              self.question.templateImageId = "";
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              self.question.imageUrl = "";
              self.question.imageId = "";
              window.$('#file_upload[type="file"]').val(null);
            }
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    },
    customVideoButtonHandler(val) {
      if (this.question && this.question.type && this.question.type === "SurveyInstruction") {
        this.editorFocused = this.$refs["privacyPolicyEditor"].quill;
      }
      if (val && this.editorFocused) {
        this.$refs.activityVideoUploadModal.show();
      }
    },
    insertVideoInEditor(data) {
      const length = this.editorFocused.getSelection() ? this.editorFocused.getSelection().index : this.editorFocused.selection.savedRange.index;
      this.editorFocused.insertEmbed(length, "uploadedVideo", data);
      this.editorFocused.setSelection(length + 1);
    },
    initLocalVideoUploadButton() {
      // initialize "custom upload" button style
      this.$nextTick(() => {
        const videoButton = document.querySelector(".ql-localVideoUpload"); // "QL -" is the prefix automatically added by the plug-in
        if (videoButton) {
          //Add a style and initialize the style of the icon with fontawesome
          videoButton.classList.add("fa");
          videoButton.classList.add("fa-video-camera");
          videoButton.style.cssText = "color: #999; padding: 6px";
        }
      });
    },
    onEditorReady(editor) {
      this.editorFocused = editor;
    },
    onEditorFocus(quill) {
      this.editorFocused = quill;
    },
    validateImage(image) {
      const isValid = image.name.match(/.(png|jpg|svg)$/i);
      return isValid;
    },
    closeModal() {
      window.$("#instructionModal").modal("hide");
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      const title = this.stripHtml(question.formattedTitle);
      const formattedInformation = this.stripHtml(question.formattedInformation);

      if ((title == "undefined" && formattedInformation == "undefined") || (title.trim() == "" && formattedInformation.trim() == "") || (title.length == 0 && formattedInformation.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Screen title or screen content is required.";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      const info = this.stripHtml(question.formattedInformation);
      if ((_.isUndefined(question.formattedInformation) || info.length == 0 || info.trim() == "") && (!title || question.formattedTitle === undefined || _.isUndefined(question.formattedBody) || title.trim() == "" || title.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      return { isValid: true };
    }
  }
};
</script>

<style lang="scss" scoped>
.instruction_title {
  word-break: break-all;
  font-size: 18px;
  font-weight: 500;
}

.instruction_info {
  word-break: break-all;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}

.example {
  color: #4c8ce4;
  cursor: pointer;
}

.file_container1 [type="file"] {
  cursor: pointer;
  display: block;
  font-size: 20px;
  filter: alpha(opacity=0);
  width: 100px;
  height: 40px;
  max-height: 50px;
  //   max-width: 200px;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;
  left: 0;
}
.file_container1 {
  margin-top: 5px;
  color: #555;
}
.file_container1 [type="file"] {
  cursor: pointer;
}
.file_container_text1 {
  background-color: #ddd;
  padding: 5px;
  width: 100%;
  display: block;
  border-radius: 4px;
  text-align: center;
}

.img_size {
  width: 100%;
  height: 100%;
  border: 1px solid #d3dfe4;
}
.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -38px;
}
.question-container {
  display: unset !important;
}
.content_flow_set {
  overflow: hidden !important;
}
.activity-configurator-step-view-mode h1 strong,
.activity-configurator-step-view-mode h2 strong,
.activity-configurator-step-view-mode h3 strong {
  font-weight: 700;
}
.activity-configurator-step-view-mode {
  h1,
  h2,
  h3 {
    font-weight: 200;
    strong {
      font-weight: bold;
    }
  }
  .instruction_title {
    h1,
    h2,
    h3 {
      font-weight: 200;
      strong {
        font-weight: bold !important;
      }
    }
  }
}
</style>
